// =============================================================================
// Bolt Event System Types (camelCase schema)
// =============================================================================
/**
 * Thread context for events
 */
export var EventThread;
(function (EventThread) {
    EventThread["UI"] = "UI";
    EventThread["Net"] = "NET";
})(EventThread || (EventThread = {}));
/**
 * Bolt event types for comprehensive performance tracking
 */
export var BoltEventType;
(function (BoltEventType) {
    BoltEventType["Action"] = "ACTION";
    BoltEventType["UrlWrite"] = "URL_WRITE";
    BoltEventType["UrlRead"] = "URL_READ";
    BoltEventType["ContextWrite"] = "CONTEXT_WRITE";
    BoltEventType["ContextRead"] = "CONTEXT_READ";
    BoltEventType["Render"] = "RENDER";
    BoltEventType["Commit"] = "COMMIT";
    BoltEventType["QueryStart"] = "QUERY_START";
    BoltEventType["QueryResolve"] = "QUERY_RESOLVE";
    BoltEventType["Paint"] = "PAINT";
    BoltEventType["LongTask"] = "LONG_TASK";
    BoltEventType["Idle"] = "IDLE";
})(BoltEventType || (BoltEventType = {}));
/**
 * Render phase in React lifecycle
 */
export var RenderPhase;
(function (RenderPhase) {
    RenderPhase["Render"] = "render";
    RenderPhase["Commit"] = "commit";
    RenderPhase["Passive"] = "passive";
})(RenderPhase || (RenderPhase = {}));
//# sourceMappingURL=types.js.map